module.exports = __webpack_public_path__ + "img/10_penguin.3b703e2f.jpg";